import { RoundButton } from '@cian/ui-kit/button';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IFavoriteButtonProps {
  isActive: boolean;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const FavoriteButton: React.FC<IFavoriteButtonProps> = ({ isActive, onClick }) => {
  return (
    <RoundButton
      icon={
        isActive ? (
          // FIXME: Грязный хак, чтобы `RoundButton` не перетирал `color`
          <span>
            <IconToggleHeartOn16 color="icon-negative-default" aria-label="heartActive" display="block" />
          </span>
        ) : (
          <IconToggleHeartOff16 color="icon-inverted-default" aria-label="heart" display="block" />
        )
      }
      size="M"
      title="Избранное"
      data-name="FavoriteButton"
      theme="fill_dark"
      onClick={onClick}
    />
  );
};
